!(function (e) {
    "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof define && define.amd
        ? define([], e)
        : (("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).EventEmitter3 = e());
})(function () {
    return (function e(t, n, o) {
        function r(a, l) {
            if (!n[a]) {
                if (!t[a]) {
                    var s = "function" == typeof require && require;
                    if (!l && s) return s(a, !0);
                    if (i) return i(a, !0);
                    var c = Error("Cannot find module '" + a + "'");
                    throw ((c.code = "MODULE_NOT_FOUND"), c);
                }
                var d = (n[a] = { exports: {} });
                t[a][0].call(
                    d.exports,
                    function (e) {
                        return r(t[a][1][e] || e);
                    },
                    d,
                    d.exports,
                    e,
                    t,
                    n,
                    o
                );
            }
            return n[a].exports;
        }
        for (var i = "function" == typeof require && require, a = 0; a < o.length; a++) r(o[a]);
        return r;
    })(
        {
            1: [
                function (e, t, n) {
                    "use strict";
                    var o = Object.prototype.hasOwnProperty,
                        r = "~";
                    function i() {}
                    function a(e, t, n) {
                        (this.fn = e), (this.context = t), (this.once = n || !1);
                    }
                    function l(e, t, n, o, i) {
                        if ("function" != typeof n) throw TypeError("The listener must be a function");
                        var l = new a(n, o || e, i),
                            s = r ? r + t : t;
                        return e._events[s] ? (e._events[s].fn ? (e._events[s] = [e._events[s], l]) : e._events[s].push(l)) : ((e._events[s] = l), e._eventsCount++), e;
                    }
                    function s(e, t) {
                        0 == --e._eventsCount ? (e._events = new i()) : delete e._events[t];
                    }
                    function c() {
                        (this._events = new i()), (this._eventsCount = 0);
                    }
                    Object.create && ((i.prototype = Object.create(null)), new i().__proto__ || (r = !1)),
                        (c.prototype.eventNames = function () {
                            var e,
                                t,
                                n = [];
                            if (0 === this._eventsCount) return n;
                            for (t in (e = this._events)) o.call(e, t) && n.push(r ? t.slice(1) : t);
                            return Object.getOwnPropertySymbols ? n.concat(Object.getOwnPropertySymbols(e)) : n;
                        }),
                        (c.prototype.listeners = function (e) {
                            var t = r ? r + e : e,
                                n = this._events[t];
                            if (!n) return [];
                            if (n.fn) return [n.fn];
                            for (var o = 0, i = n.length, a = Array(i); o < i; o++) a[o] = n[o].fn;
                            return a;
                        }),
                        (c.prototype.listenerCount = function (e) {
                            var t = r ? r + e : e,
                                n = this._events[t];
                            return n ? (n.fn ? 1 : n.length) : 0;
                        }),
                        (c.prototype.emit = function (e, t, n, o, i, a) {
                            var l = r ? r + e : e;
                            if (!this._events[l]) return !1;
                            var s,
                                c,
                                d = this._events[l],
                                u = arguments.length;
                            if (d.fn) {
                                switch ((d.once && this.removeListener(e, d.fn, void 0, !0), u)) {
                                    case 1:
                                        return d.fn.call(d.context), !0;
                                    case 2:
                                        return d.fn.call(d.context, t), !0;
                                    case 3:
                                        return d.fn.call(d.context, t, n), !0;
                                    case 4:
                                        return d.fn.call(d.context, t, n, o), !0;
                                    case 5:
                                        return d.fn.call(d.context, t, n, o, i), !0;
                                    case 6:
                                        return d.fn.call(d.context, t, n, o, i, a), !0;
                                }
                                for (c = 1, s = Array(u - 1); c < u; c++) s[c - 1] = arguments[c];
                                d.fn.apply(d.context, s);
                            } else {
                                var f,
                                    p = d.length;
                                for (c = 0; c < p; c++)
                                    switch ((d[c].once && this.removeListener(e, d[c].fn, void 0, !0), u)) {
                                        case 1:
                                            d[c].fn.call(d[c].context);
                                            break;
                                        case 2:
                                            d[c].fn.call(d[c].context, t);
                                            break;
                                        case 3:
                                            d[c].fn.call(d[c].context, t, n);
                                            break;
                                        case 4:
                                            d[c].fn.call(d[c].context, t, n, o);
                                            break;
                                        default:
                                            if (!s) for (f = 1, s = Array(u - 1); f < u; f++) s[f - 1] = arguments[f];
                                            d[c].fn.apply(d[c].context, s);
                                    }
                            }
                            return !0;
                        }),
                        (c.prototype.on = function (e, t, n) {
                            return l(this, e, t, n, !1);
                        }),
                        (c.prototype.once = function (e, t, n) {
                            return l(this, e, t, n, !0);
                        }),
                        (c.prototype.removeListener = function (e, t, n, o) {
                            var i = r ? r + e : e;
                            if (!this._events[i]) return this;
                            if (!t) return s(this, i), this;
                            var a = this._events[i];
                            if (a.fn) a.fn !== t || (o && !a.once) || (n && a.context !== n) || s(this, i);
                            else {
                                for (var l = 0, c = [], d = a.length; l < d; l++) (a[l].fn !== t || (o && !a[l].once) || (n && a[l].context !== n)) && c.push(a[l]);
                                c.length ? (this._events[i] = 1 === c.length ? c[0] : c) : s(this, i);
                            }
                            return this;
                        }),
                        (c.prototype.removeAllListeners = function (e) {
                            var t;
                            return e ? ((t = r ? r + e : e), this._events[t] && s(this, t)) : ((this._events = new i()), (this._eventsCount = 0)), this;
                        }),
                        (c.prototype.off = c.prototype.removeListener),
                        (c.prototype.addListener = c.prototype.on),
                        (c.prefixed = r),
                        (c.EventEmitter = c),
                        void 0 !== t && (t.exports = c);
                },
                {},
            ],
        },
        {},
        [1]
    )(1);
}),
    (window.theme = window.theme || {}),
    (window.themeInfo = { name: "Drop" });
var Events = new EventEmitter3();
(Events.trigger = Events.emit),
    (window.WAU = window.WAU || {}),
    (WAU.Slideout = (function () {
        var e = void 0;
        function t() {
            let e = document.querySelector(".slideout--active"),
                t = e.getAttribute("data-wau-slideout"),
                n = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + t + '"]'),
                o = n.getAttribute("data-slideout-direction"),
                i = e.getAttribute("data-wau-accordions-closed");
            null !== i && WAU.Accordion.hideAll(t), r(o, n);
        }
        function n() {
            return (e = document.querySelector(".js-slideout-toggle-wrapper")).classList.contains("slideout-left--open") || e.classList.contains("slideout-right--open");
        }
        function o(t, n, o) {
            e.classList.add("slideout-" + t + "--open"), e.classList.remove("slideout-" + t + "--closed"), o.setAttribute("aria-expanded", "true");
            let r = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top),
                i = n.dataset.wauSlideout;
            Events.trigger("slideout:open:" + i),
                n.setAttribute("aria-hidden", "false"),
                setTimeout(function () {
                    n.classList.add("slideout--active"), n.classList.remove("slideout--close");
                }, 350),
                (function e(t) {
                    let n = 'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])',
                        o = t.querySelectorAll(n)[0],
                        r = t.querySelectorAll(n),
                        i = r[r.length - 1];
                    document.addEventListener("keydown", function (e) {
                        ("Tab" === e.key || 9 === e.keyCode) && (e.shiftKey ? document.activeElement === o && (i.focus(), e.preventDefault()) : document.activeElement === i && (o.focus(), e.preventDefault()));
                    }),
                        o.focus();
                })(n),
                (e.style.overflow = "hidden"),
                (e.style.position = "fixed"),
                (e.style.top = `-${r}px`),
                (e.style.width = "100%");
        }
        function r(t, n) {
            let o = document.querySelectorAll(".slideout--active"),
                r = document.querySelectorAll(".js-slideout-open"),
                i = document.querySelectorAll(".js-slideout-close");
            n && "quickview" == n.getAttribute("aria-controls") && (document.querySelector(".js-quickview-content").innerHTML = ""),
                e.classList.remove("slideout-" + t + "--open"),
                e.classList.add("slideout-" + t + "--closed"),
                o.forEach(function (e) {
                    let t = e.getAttribute("data-wau-accordions-closed"),
                        n = e.getAttribute("data-wau-slideout");
                    null !== t && WAU.Accordion.hideAll(n),
                        Events.trigger("slideout:close:" + n),
                        e.classList.remove("slideout--active"),
                        e.classList.add("slideout--close"),
                        setTimeout(function () {
                            e.setAttribute("aria-hidden", "true");
                        }, 350),
                        e.querySelector(".js-slideout-close") && e.querySelector(".js-slideout-close").blur();
                }),
                r.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                i.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                });
            let a = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
            e.style.removeProperty("overflow"), e.style.removeProperty("position"), e.style.removeProperty("top"), e.style.removeProperty("width"), window.scrollTo(0, a);
        }
        function i(t, n, o) {
            let r = document.createElement("aside"),
                i = document.createElement("div"),
                a = document.createElement("div"),
                l = document.querySelector('[data-wau-slideout-target="' + n + '"]'),
                s = document.querySelector('[data-wau-slideout-content="' + n + '"]'),
                c = "slideout-" + n;
            if (
                ((o = o || e),
                s.hasAttribute("data-wau-accordions-closed") && r.setAttribute("data-wau-accordions-closed", ""),
                r.classList.add("slideout"),
                r.classList.add("slideout__drawer-" + t),
                r.setAttribute("data-wau-slideout", n),
                r.setAttribute("id", c),
                i.classList.add("slideout__inner-wrapper"),
                i.classList.add("slideout__general-slide__wrapper"),
                (a.innerHTML = s.innerHTML),
                a.classList.add("slideout__inner-content-container"),
                (s.innerHTML = ""),
                s.dataset.wauSlideoutButton && "true" == s.dataset.wauSlideoutButton)
            ) {
                let d = createCloser(n, t);
                i.prepend(d);
            }
            return r.appendChild(i), i.appendChild(a), l.setAttribute("aria-controls", c), o.appendChild(r), r;
        }
        document.addEventListener("keyup", function (e) {
            "Escape" === e.key && (e.preventDefault(), t());
        }),
            document.addEventListener("click", function (e) {
                e.target === document.querySelector(".js-slideout-overlay") && t();
            });
        let a = {
                openByName: function e(t) {
                    let n = document.querySelector('[data-wau-slideout-target="' + t + '"]'),
                        r = n ? n.getAttribute("data-slideout-direction") : "left",
                        i = document.querySelector('[data-wau-slideout="' + t + '"]');
                    o(r, i, n);
                },
                closeByName: function e(t) {
                    let n = document.querySelector('[data-wau-slideout-target="' + t + '"]'),
                        o = n.getAttribute("data-slideout-direction"),
                        i = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + t + '"]');
                    r(o, i);
                },
                createSlideoutEl: i,
                reloadSlideoutContents: function e(t) {
                    let n = document.querySelector('[data-wau-slideout-content="' + t + '"]'),
                        o = document.querySelector('aside[data-wau-slideout="' + t + '"]'),
                        r = o.querySelector(".slideout__inner-content-container");
                    r.innerHTML = n.innerHTML;
                },
            },
            l = {};
        return (
            (l.init = function t(n) {
                if (void 0 === n) {
                    console.log("The Slideout must have an associated name.");
                    return;
                }
                e = document.querySelector(".js-slideout-toggle-wrapper");
                let a = document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + n + '"]'),
                    l;
                a.forEach((t, r) => {
                    let a = t.getAttribute("data-slideout-direction");
                    t && (l = document.querySelector(`aside[data-wau-slideout=${n}]`)),
                        l || (l = i(a, n, e)),
                        l.setAttribute("aria-hidden", "true"),
                        Events.trigger("slideout:active:" + n),
                        t.addEventListener("click", function () {
                            o(a, l, t);
                        });
                });
                let s = document.querySelectorAll(".js-slideout-close");
                s.forEach((e, t) => {
                    let n = e.getAttribute("data-slideout-direction");
                    e.addEventListener("click", function () {
                        r(n, e);
                    });
                });
            }),
            Object.keys(a).forEach(function (e) {
                l["_" + e] = a[e];
            }),
            l
        );
    })()),
    (WAU.Modal = (function () {
        var e = void 0;
        function t() {
            let e = document.querySelector(".modal--active");
            e.getAttribute("data-wau-modal");
            let t = e.querySelector(".js-modal-close");
            r(t);
        }
        function n() {
            return (e = document.querySelector(".js-modal-toggle-wrapper")).classList.contains("modal--open");
        }
        function o(t, n) {
            let o = Math.abs(0 - document.querySelector(".site-wrap").getBoundingClientRect().top);
            if (
                ((e.style.width = "100%"),
                t.hasAttribute("data-wau-modal-full") ? (e.style.overflowY = "hidden") : (t.style.top = `calc(${o}px + 10vh)`),
                e.classList.add("modal--open"),
                e.classList.remove("modal--closed"),
                t.classList.add("modal--active"),
                t.getAttribute("data-wau-modal"))
            ) {
                var r = t.getAttribute("data-wau-modal"),
                    r = "modal-" + r + "--open";
                e.classList.add(r);
            }
            n.setAttribute("aria-expanded", "true");
        }
        function r(t) {
            let n = document.querySelectorAll(".modal--active"),
                o = document.querySelectorAll(".js-modal-open"),
                r = document.querySelectorAll(".js-modal-close");
            t && "quickview" == t.getAttribute("aria-controls") && (document.querySelector(".js-quickview-content").innerHTML = ""),
                e.classList.remove("modal--open"),
                e.classList.add("modal--closed"),
                n.forEach(function (t) {
                    if (t.getAttribute("data-wau-modal")) {
                        var n = t.getAttribute("data-wau-modal"),
                            n = "modal-" + n + "--open";
                        e.classList.remove(n);
                    }
                    t.classList.remove("modal--active"), t.hasAttribute("data-wau-modal-full") && (e.style.overflowY = "unset");
                }),
                o.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                r.forEach(function (e) {
                    e.setAttribute("aria-expanded", "false");
                }),
                e.style.removeProperty("overflow"),
                e.style.removeProperty("position"),
                e.style.removeProperty("padding-right"),
                e.style.removeProperty("top"),
                e.style.removeProperty("width");
        }
        function i(t, n) {
            let o = document.createElement("div"),
                r = document.createElement("div"),
                i = document.createElement("div"),
                a = document.querySelector('[data-wau-modal-target="' + t + '"]'),
                l = document.querySelector('[data-wau-modal-content="' + t + '"]'),
                s = "modal-" + t;
            (n = n || e),
                o.classList.add("modal"),
                o.classList.add("modal__container"),
                o.setAttribute("data-wau-modal", t),
                o.setAttribute("id", s),
                l && l.hasAttribute("data-wau-modal-full") && o.setAttribute("data-wau-modal-full", ""),
                r.classList.add("modal__inner-wrapper"),
                r.classList.add("modal__general-modal__wrapper"),
                (i.innerHTML = l.innerHTML),
                i.classList.add("modal__inner-content-container");
            let c = (function e(t) {
                let n = document.createElement("div"),
                    o = document.createElement("button"),
                    r = document.createElement("div");
                return (
                    n.classList.add("slideout__trigger--close"),
                    n.classList.add("slideout__trigger-" + t + "__wrapper"),
                    n.classList.add("slideout__trigger-general-modal__wrapper"),
                    o.classList.add("slideout__trigger-" + t),
                    o.classList.add("slideout__trigger-general-modal"),
                    o.classList.add("js-modal-close"),
                    o.setAttribute("aria-controls", "modal-" + t),
                    o.setAttribute("aria-label", "Close modal"),
                    r.classList.add("icn-close"),
                    o.appendChild(r),
                    n.appendChild(o),
                    n
                );
            })(t);
            return r.prepend(c), o.appendChild(r), r.appendChild(i), a.setAttribute("aria-controls", s), n.appendChild(o), o;
        }
        document.addEventListener("keyup", function (e) {
            "Escape" === e.key && (e.preventDefault(), t());
        }),
            document.addEventListener("click", function (e) {
                e.target === document.querySelector(".js-modal-overlay") && t();
            });
        let a = {
                openByName: function e(t) {
                    let n = document.querySelector('[data-wau-modal-target="' + t + '"]'),
                        r = document.querySelector('[data-wau-modal="' + t + '"]');
                    o(r, n);
                },
                closeByName: function e(t) {
                    document.querySelector('[data-wau-modal-target="' + t + '"]');
                    let n = document.querySelector('.js-modal-open[data-wau-modal-target="' + t + '"]');
                    r(n);
                },
                createModalEl: i,
            },
            l = {};
        return (
            (l.init = function t(n) {
                if (void 0 === n) {
                    console.log("The Modal must have an associated name.");
                    return;
                }
                e = document.querySelector(".js-modal-toggle-wrapper");
                let a = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + n + '"]'),
                    l;
                a && (l = document.querySelector(`div[data-wau-modal=${n}]`)),
                    l || (l = i(n, e)),
                    a.forEach((e, t) => {
                        e.addEventListener("click", function () {
                            o(l, e);
                        });
                    });
                let s = document.querySelectorAll(".js-modal-close");
                s.forEach(function (e) {
                    e.addEventListener("click", function () {
                        r(e);
                    });
                });
            }),
            Object.keys(a).forEach(function (e) {
                l["_" + e] = a[e];
            }),
            l
        );
    })()),
    (WAU.Accordion = (function () {
        let e = { show: "is-active", open: "js-accordion-is-open", mobileNavAccordion: "js-accordion-mobile-nav" },
            t = { accordion: ".js-accordion", accordionItem: ".c-accordion__item", accordionLink: ".js-accordion-link", accordionHeader: ".js-accordion-header", accordionPanel: ".c-accordion__panel" },
            n = {},
            o = function (e) {
                if (e) return e.split(".")[1];
            };
        return (
            (n.getConfigClass = function (t) {
                if (t) return !!e[t] && "" != e[t] && e[t];
            }),
            (n.hide = function (e) {
                e.setAttribute("aria-expanded", "false"), e.parentNode.classList.remove("accordion-expanded");
                let t = document.querySelector(`#${e.getAttribute("aria-controls")}`);
                t.setAttribute("hidden", ""),
                    setTimeout(function () {
                        t.style.display = "none";
                    }, 350);
            }),
            (n.hideAll = function (e) {
                let t = document.querySelector('[data-accordion-family="' + e + '"]');
                if (!t) return !1;
                let n = document.querySelectorAll('[data-accordion-family="' + e + '"] > .js-accordion-header');
                n.forEach((e, t) => {
                    let n = e.querySelector('[data-toggle="accordion"]');
                    n.setAttribute("aria-expanded", "false"), n.parentNode.classList.remove("accordion-expanded");
                    let o = document.querySelector(`#${n.getAttribute("aria-controls")}`);
                    o.setAttribute("hidden", ""),
                        setTimeout(function () {
                            o.style.display = "none";
                        }, 350);
                });
            }),
            (n.show = function (t, o) {
                let r = document.querySelector(`#${t.getAttribute("aria-controls")}`),
                    i = t.closest(r.getAttribute("data-parent")),
                    a = !!(o || i.hasAttribute("data-accordion-allow-multiple")),
                    l = i.classList.contains(e.mobileNavAccordion);
                if (!a && r.hasAttribute("data-parent")) {
                    let s = "";
                    if (!(s = l ? ':scope > li > [aria-expanded="true"]' : ':scope > [aria-expanded="true"]')) return;
                    let c = t.closest(r.getAttribute("data-parent")).querySelectorAll(s);
                    if (!c) return;
                    c.forEach(function (e) {
                        n.hide(e);
                    });
                }
                t.setAttribute("aria-expanded", "true"), t.parentNode.classList.add("accordion-expanded"), r.removeAttribute("hidden"), (r.style.display = "block");
            }),
            (n.toggle = function (e, t) {
                if ("true" == e.getAttribute("aria-expanded")) {
                    n.hide(e);
                    return;
                }
                n.show(e, t);
            }),
            (n.init = function () {
                document.querySelectorAll(`[data-toggle="accordion"]:not(.${e.open})`).forEach(function (e, t) {
                    n.hide(e);
                }),
                    document.addEventListener("keydown", function (n) {
                        let r = n.target,
                            i = n.which.toString(),
                            a = { preventScroll: !1 },
                            l = r.classList.contains("dropdown-arrow");
                        if ((r.classList.contains(o(t.accordionHeader)) || r.classList.contains(o(t.accordionLink)) || l) && i.match(/38|40/)) {
                            let s = !!r.closest(t.accordion).classList.contains(e.mobileNavAccordion),
                                c = s ? `:scope > li > ${t.accordionLink}` : `:scope > ${t.accordionHeader}`,
                                d = r.closest(t.accordion).querySelectorAll(c);
                            if (s && l) {
                                r.previousElementSibling.focus(a);
                                return;
                            }
                            let u;
                            d.forEach(function (e, t) {
                                e == r && (u = t);
                            });
                            let f = i.match(/34|40/) ? 1 : -1,
                                p = d.length,
                                y = (u + p + f) % p;
                            d[y].focus(a);
                        }
                    }),
                    document.addEventListener("click", function (e) {
                        let t = e.target.matches('[data-toggle="accordion"]') ? e.target : e.target.closest('[data-toggle="accordion"]');
                        if (!t) return !1;
                        e.preventDefault(), n.toggle(t);
                    }),
                    document.addEventListener("click", function (e) {
                        if (e.target.classList.contains("js-accordion-link") && "" == e.target.getAttribute("href")) {
                            e.preventDefault();
                            let t = e.target.parentNode.querySelector('[data-toggle="accordion"]');
                            n.toggle(t);
                        }
                    });
            }),
            n
        );
    })()),
    (WAU.Helpers = (function () {
        var e = !1;
        function t() {
            return e;
        }
        return {
            setTouch: function t() {
                e = !0;
            },
            isTouch: t,
            debounce: function e(t, n, o) {
                var r;
                return function () {
                    var e = this,
                        i = arguments,
                        a = function () {
                            (r = null), o || t.apply(e, i);
                        },
                        l = o && !r;
                    clearTimeout(r), (r = setTimeout(a, n)), l && t.apply(e, i);
                };
            },
            makeSticky: function e(t, n, o) {
                let r = document.querySelector(".js-clear-element"),
                    i = document.querySelector(n);
                (height = r.classList.contains("over-content--true") && window.matchMedia("(min-width: 968px)").matches ? "0px" : o + "px"),
                    window.pageYOffset > t ? (i.classList.add("sticky--active"), (r.style.height = height)) : (i.classList.remove("sticky--active"), (r.style.height = "0px"));
            },
            showHide: function e(t, n) {
                var t = document.getElementById(t);
                t.classList.remove("hide"), t.classList.add("show"), (t.style.display = "block");
                var n = document.getElementById(n);
                n.classList.remove("show"), n.classList.add("hide"), (n.style.display = "none");
            },
            Toggle: function e(t) {
                var n = document.getElementById(t);
                n.classList.contains("animate-hide")
                    ? (n.classList.remove("animate-hide", "fadeOut"), n.classList.add("animate-show", "fadeIn"), (n.style.visibility = "visible"))
                    : (n.classList.remove("animate-show", "fadeIn"), n.classList.add("animate-hide", "fadeOut"), (n.style.visibility = "hidden"));
            },
            toggleClass: function e(t, n) {
                var o = document.getElementById(t);
                if (!o) return !1;
                o.classList.contains(n) ? o.classList.remove(n) : o.classList.add(n);
            },
            Accordion: function e(t, n, o) {
                let r = t.querySelector(o);
                if (!t.querySelector(n)) return !1;
                t.querySelector(n).addEventListener("click", function (e) {
                    e.preventDefault(),
                        this.classList.contains("closed")
                            ? (this.classList.remove("closed"), this.parentElement.classList.remove("closed"), this.setAttribute("aria-expanded", "true"))
                            : (this.classList.add("closed"), this.parentElement.classList.add("closed"), this.setAttribute("aria-expanded", "false")),
                        r.classList.contains("closed") ? (r.classList.remove("closed"), (r.style.display = "block")) : (r.classList.add("closed"), (r.style.display = "none"));
                });
            },
            fadeToggle: function e(t, n) {
                "none" === t.style.display
                    ? ((t.style.opacity = 0),
                      (t.style.display = n || "block"),
                      (function e() {
                          var n = parseFloat(t.style.opacity);
                          (n += 0.1) > 1 || ((t.style.opacity = n), requestAnimationFrame(e));
                      })())
                    : t.style.display === (n || "block") &&
                      ((t.style.opacity = 1),
                      (function e() {
                          (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(e);
                      })());
            },
            fadeOut: function e(t) {
                (t.style.opacity = 1),
                    (function e() {
                        (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(e);
                    })();
            },
            fadeIn: function e(t, n) {
                (t.style.opacity = 0),
                    (t.style.display = n || "block"),
                    (function e() {
                        var n = parseFloat(t.style.opacity);
                        (n += 0.1) > 1 || ((t.style.opacity = n), requestAnimationFrame(e));
                    })();
            },
            getScrollbarWidth: function e() {
                let t = document.createElement("div");
                (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
                let n = document.createElement("div");
                t.appendChild(n);
                let o = t.offsetWidth - n.offsetWidth;
                return t.parentNode.removeChild(t), o;
            },
            smoothScrollTo: function e(t, n, o) {
                let r = window.scrollX || window.pageXOffset,
                    i = window.scrollY || window.pageYOffset,
                    a = t - r,
                    l = n - i,
                    s = new Date().getTime(),
                    c = function (e, t, n, o) {
                        return (e /= o / 2) < 1 ? (n / 2) * e * e * e * e + t : (-n / 2) * ((e -= 2) * e * e * e - 2) + t;
                    },
                    d = window.setInterval(function () {
                        let e = new Date().getTime() - s,
                            t = c(e, r, a, o),
                            n = c(e, i, l, o);
                        e >= o && window.clearInterval(d), window.scrollTo(t, n);
                    }, 1e3 / 60);
            },
            wrapIframe: function e(t) {
                t.iframes.forEach(function (e) {
                    var n = document.createElement("div");
                    n.classList.add(t.iframeWrapperClass), e.parentNode.insertBefore(n, e), n.appendChild(e), (e.src = e.src);
                });
            },
            wrapTable: function e(t) {
                t.tables.forEach(function (e) {
                    var n = document.createElement("div");
                    n.classList.add(t.tableWrapperClass), e.parentNode.insertBefore(n, e), n.appendChild(e);
                });
            },
            scriptLoader: function e() {
                let t = (e, t) =>
                    new Promise((n, o) => {
                        var r;
                        let i = window.document.createElement("script");
                        for (let a in ((i.src = e), (i.async = !0), (i.crossOrigin = "anonymous"), (t = t || {}))) i[a] = t[a];
                        i.addEventListener(
                            "load",
                            () => {
                                n(i);
                            },
                            !1
                        ),
                            i.addEventListener(
                                "error",
                                () => {
                                    o(i);
                                },
                                !1
                            ),
                            ((r = e), document.querySelectorAll(`script[src="${r}"]`).length > 0) ? n(i) : window.document.head.appendChild(i);
                    });
                (this.load = (e, n) => (Array.isArray(e) || (e = [e]), Promise.all(e.map((e) => t(e, n))))),
                    (this.loadChain = function (e) {
                        let t = Array.isArray(arguments) ? arguments : Array.prototype.slice.call(arguments),
                            n = this.require(t.shift()),
                            o = this;
                        return t.length
                            ? n.then(() => {
                                  o.requireChain(...t);
                              })
                            : n;
                    });
            },
            scriptExists: function e(t) {
                return document.querySelectorAll(`script[src="${t}"]`).length > 0;
            },
            isElementPastEdge: function e(t) {
                let n = t.getBoundingClientRect(),
                    o = n.left,
                    r = n.width,
                    i = (document.documentElement.clientHeight, document.documentElement.clientWidth);
                return o + r >= i;
            },
            formatMoney: function e(t, n) {
                "string" == typeof t && (t = t.replace(".", ""));
                let o = "",
                    r = /\{\{\s*(\w+)\s*\}\}/,
                    i = n || "${{amount}}";
                function a(e, t = 2, n = ",", o = ".") {
                    if (isNaN(e) || null == e) return 0;
                    e = (e / 100).toFixed(t);
                    let r = e.split("."),
                        i = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`),
                        a = r[1] ? o + r[1] : "";
                    return i + a;
                }
                switch (i.match(r)[1]) {
                    case "amount":
                        o = a(t, 2);
                        break;
                    case "amount_no_decimals":
                        o = a(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        o = a(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        o = a(t, 0, ".", ",");
                }
                return i.replace(r, o);
            },
        };
    })()),
    (WAU.a11yHelpers = (function () {
        let e = !1;
        function t(e, t, n) {
            let o = e.querySelectorAll('a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'),
                r = o.length;
            var i = 0;
            for (let a = 0; a < o.length; a += 1) o[a] === t && (i = a);
            return "next" === n ? (i === r - 1 ? o[0] : o[i + 1]) : "prev" === n ? (0 === i ? o[r - 1] : o[i - 1]) : void 0;
        }
        function n(e, n) {
            return t(e, n, "next");
        }
        function o(e, n) {
            return t(e, n, "prev");
        }
        return {
            setUpAriaExpansion: function e() {
                let t = document.querySelectorAll(".js-aria-expand");
                t.forEach(function (e) {
                    e.addEventListener("mouseover", function (t) {
                        e.setAttribute("aria-expanded", "true");
                    }),
                        e.addEventListener("mouseout", function (t) {
                            e.setAttribute("aria-expanded", "false");
                        });
                });
            },
            setUpAccessibleNavigationMenus: function t() {
                function n() {
                    let e = document.querySelectorAll(".navigation__menuitem--active");
                    e.forEach(function (e) {
                        e.classList.remove("navigation__menuitem--active"), e.setAttribute("aria-expanded", "false");
                    });
                }
                function o() {
                    let e = document.querySelectorAll(".js-menuitem-with-nested-dropdown");
                    e.forEach(function (e) {
                        e.classList.remove("dropdown__menuitem--active"), e.setAttribute("aria-expanded", "false");
                    });
                }
                e ||
                    document.addEventListener("keyup", function (e) {
                        if ("Escape" === e.key) {
                            let t = document.querySelectorAll(".dropdown__menuitem--active"),
                                r = document.querySelectorAll(".navigation__menuitem--active");
                            if ((e.preventDefault(), t.length >= 1)) {
                                o();
                                return;
                            }
                            if (r.length >= 1) {
                                n();
                                return;
                            }
                        }
                    }),
                    e ||
                        document.addEventListener("keydown", function (e) {
                            if ("Enter" === e.key) {
                                if (
                                    ((document.activeElement.classList.contains("js-open-dropdown-on-key") || document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) &&
                                        (e.stopPropagation(), e.preventDefault()),
                                    document.activeElement.parentNode.classList.contains("navigation__menuitem--active"))
                                ) {
                                    n();
                                    return;
                                }
                                if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) {
                                    o();
                                    return;
                                }
                                if ((document.activeElement.parentNode.classList.contains("js-first-level") && n(), document.activeElement.classList.contains("js-open-dropdown-on-key"))) {
                                    document.activeElement.parentNode.classList.add("navigation__menuitem--active");
                                    return;
                                }
                                if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
                                    var t;
                                    document.activeElement.parentNode.classList.add("dropdown__menuitem--active"),
                                        (t = document.activeElement.parentNode),
                                        setTimeout(function () {
                                            WAU.Helpers.isElementPastEdge(t) ? t.classList.add("dropdown--edge") : t.classList.remove("dropdown--edge");
                                        }, 0);
                                    return;
                                }
                            }
                        }),
                    (e = !0);
            },
            focusOnElement: function e(t) {
                let n = t.querySelector('a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])');
                n && n.focus();
            },
        };
    })()),
    (WAU.Sections = void document.querySelectorAll("[data-section-type]").forEach(function (e) {
        let t = (t, o) => {
            t.forEach((t) => {
                t.isIntersecting && (n(e), e.hasAttribute("data-section-loaded") && e.setAttribute("data-section-loaded", "true"));
            });
        };
        function n(e) {
            if (e.dataset.assetUrl) {
                let t = new WAU.Helpers.scriptLoader();
                t.load([e.dataset.assetUrl]).then(({ length: t }) => {
                    console.log(e.dataset.sectionType + " script loaded");
                });
            }
        }
        new IntersectionObserver(t).observe(e),
            document.addEventListener("shopify:section:select", function (t) {
                e.dataset.sectionId == t.detail.sectionId && e.hasAttribute("data-section-loaded") && t.target.classList.add("section--reloaded");
            }),
            document.addEventListener("shopify:section:load", function (e) {
                n(e.target.querySelector("[data-section-type]")), e.target.classList.add("section--reloaded");
            });
    })),
    (WAU.ProductGridVideo = {
        init: function e() {
            document.querySelectorAll(".js-bg-video-wrapper").forEach(function (e) {
                WAU.ProductGridVideo.initVideo(e);
            });
        },
        initVideo: function e(t) {
            var n = t.dataset.productId,
                o = t.dataset.videoUrl,
                r = ".js-bg-video-" + n,
                i = { mp4: o },
                a = new vidbg(r, i),
                l = r + " video",
                l = document.querySelector(l);
            (l.muted = !0),
                document.addEventListener("shopify:section:unload", function (e) {
                    WAU.ProductGridVideo.destroyVideo(a);
                }),
                document.addEventListener("shopify:section:select", function (e) {
                    WAU.ProductGridVideo.reinitVideo(r, i);
                });
        },
        destroyVideo: function e(t) {
            t.destroy();
        },
        reinitVideo: function e(t, n) {
            return new vidbg(t, n);
        },
    }),
    (WAU.LocalizationForm = function (e) {
        function t() {
            e.querySelector("button").setAttribute("aria-expanded", "false"), e.querySelector("ul").setAttribute("hidden", !0);
        }
        function n(t) {
            t.preventDefault();
            let n = e.querySelector("form");
            (e.querySelector('input[name="locale_code"], input[name="country_code"]').value = t.currentTarget.dataset.value), n && n.submit();
        }
        e.querySelector("button").addEventListener("click", function t() {
            e.querySelector("button").focus(), e.querySelector("ul").toggleAttribute("hidden"), e.querySelector("button").setAttribute("aria-expanded", ("false" === e.querySelector("button").getAttribute("aria-expanded")).toString());
        }),
            e.querySelector("button").addEventListener("focusout", function e(n) {
                let o = n.relatedTarget && "BUTTON" === n.relatedTarget.nodeName;
                (null === n.relatedTarget || o) && t();
            }),
            e.addEventListener("keyup", function n(o) {
                "ESCAPE" === o.code.toUpperCase() && (t(), e.querySelector("button").focus());
            }),
            e.querySelectorAll("a").forEach((e) => e.addEventListener("click", n));
    }),
    void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var n = 0, o = e.options.length; n < o; n++) {
            var r = e.options[n];
            if (t == r.value || t == r.innerHTML) return (e.selectedIndex = n), n;
        }
    }),
    (Shopify.addListener = function (e, t, n) {
        e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent("on" + t, n);
    }),
    (Shopify.postLink = function (e, t) {
        var n = (t = t || {}).method || "post",
            o = t.parameters || {},
            r = document.createElement("form");
        for (var i in (r.setAttribute("method", n), r.setAttribute("action", e), o)) {
            var a = document.createElement("input");
            a.setAttribute("type", "hidden"), a.setAttribute("name", i), a.setAttribute("value", o[i]), r.appendChild(a);
        }
        document.body.appendChild(r), r.submit(), document.body.removeChild(r);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, n) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(n.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = this.countryEl.options[this.countryEl.selectedIndex],
                n = JSON.parse(t.getAttribute("data-provinces"));
            if ((this.clearOptions(this.provinceEl), n && 0 == n.length)) this.provinceContainer.style.display = "none";
            else {
                for (var o = 0; o < n.length; o++) {
                    var t = document.createElement("option");
                    (t.value = n[o][0]), (t.innerHTML = n[o][1]), this.provinceEl.appendChild(t);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            for (var n = 0; n < t.length; n++) {
                var o = document.createElement("option");
                (o.value = t[n]), (o.innerHTML = t[n]), e.appendChild(o);
            }
            t.length;
        },
    }),
    WAU.Accordion.init(),
    WAU.Slideout.init("mobile-navigation"),
    document.querySelectorAll("[data-localization-form]").forEach(function (e) {
        WAU.LocalizationForm(e);
    }),
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".js-bg-video-wrapper") && WAU.ProductGridVideo.init();
    }),
    document.addEventListener("shopify:section:select", function (e) {
        document.querySelectorAll(".js-bg-video-wrapper") && WAU.ProductGridVideo.init(), e.target.querySelector("[data-localization-form]") && WAU.LocalizationForm(e.target.querySelector("[data-localization-form]"));
    }),
    WAU.Helpers.wrapIframe({ iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]'), iframeWrapperClass: "video-wrapper" }),
    WAU.Helpers.wrapIframe({ iframes: document.querySelectorAll('.rte iframe[src*="player.vimeo"]'), iframeWrapperClass: "video-wrapper" }),
    WAU.Helpers.wrapTable({ tables: document.querySelectorAll(".rte table"), tableWrapperClass: "table-wrapper" }),
    (log = function () {
        var e = Array.prototype.slice.call(arguments);
        return e.unshift(console), Function.prototype.bind.apply(console.log, e);
    })("Drop Version 3.3.0 by Underground", { bar: 1 })(),
    document.querySelectorAll(".js-notify-submit").forEach(function (e) {
        e.addEventListener("click", function (t) {
            t.preventDefault();
            var n = t.target.dataset.productId,
                o = window.location.href;
            (function e(t, n, o) {
                if (t.checkValidity()) {
                    var r, i;
                    (r = n), (i = o), sessionStorage.setItem("prev_url", r), sessionStorage.setItem("form_product", i), t.submit();
                } else {
                    var a = t.querySelector(".js-form-error");
                    WAU.Helpers.fadeIn(a, "block"),
                        setTimeout(function () {
                            WAU.Helpers.fadeOut(a);
                        }, 2e3);
                }
                return !1;
            })(e.closest("form"), o, n);
        });
    }),
    document.querySelectorAll(".js-notify-contact-form").forEach(function (e) {
        var t = sessionStorage.getItem("form_product");
        e.id == t
            ? ((e.querySelector(".notify-form__success-wrapper").style.display = "block"),
              (e.querySelector(".notify-form__subscribe-wrapper").style.display = "none"),
              e.parentNode.previousSibling && (e.parentNode.previousSibling.style.display = "none"))
            : ((e.querySelector(".notify-form__success-wrapper").style.display = "none"), (e.querySelector(".notify-form__subscribe-wrapper").style.display = "block"));
    }),
    window.location.href.indexOf("collections") > -1 && window.location.href.indexOf("contact_posted") > -1 && null !== sessionStorage.getItem("prev_url") && (window.location.href = sessionStorage.getItem("prev_url")),
    (function e() {
        document.querySelector('[data-wau-modal="new-address"]') && WAU.Modal.init("new-address");
        var t = document.querySelectorAll("[data-wau-modal-content]");
        t &&
            t.forEach((e, t) => {
                e.dataset.wauModalContent;
            });
        var n = document.querySelectorAll("[data-wau-modal]");
        n &&
            n.forEach((e, t) => {
                e.dataset.wauModal.includes("edit-address") && WAU.Modal.init(e.dataset.wauModal);
            });
    })(),
    (function e() {
        var t = function (e) {
            if (e.target.checkValidity()) return !0;
            e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            for (var t = e.target.elements, n = 0, o = t.length; n < o; n++) {
                var r = t[n];
                if (!0 === r.willValidate && !0 !== r.validity.valid) {
                    var i = r.validationMessage,
                        a = r.parentNode,
                        l = document.createElement("small");
                    l.appendChild(document.createTextNode(i)), l.classList.add("validation-message"), a.insertBefore(l, r.nextSibling), r.focus();
                    break;
                }
            }
        };
        document.addEventListener("DOMContentLoaded", function () {
            for (var e = document.querySelectorAll("form"), n = e.length - 1; n >= 0; n--) {
                var o = e[n];
                if (o.classList.contains("js-no-validate")) return !1;
                (o.noValidate = !0), o.addEventListener("submit", t);
            }
        });
    })();
